export default __webpack_public_path__ + "10.png";